module.exports = __webpack_public_path__ + "static/img/6190_phase_function_Paper_Points.fcfdda3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6190_phase_function_Paper_Points.png
// module id = HEPS
// module chunks = 0